import { Link } from 'react-router';

import type { NavigationGroup } from '@/data/navigation';
import { cn } from '@/lib/utils';

type FooterNavigationProps = {
  groups: readonly NavigationGroup[];
};

const FooterNavigation = ({ groups }: FooterNavigationProps) => (
  <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 mt-10">
    {groups.map((group) => (
      <div key={group.title}>
        <h3 className={cn('text-base font-semibold mb-3', group.headingClassName)}>
          {group.title}
        </h3>
        <ul className="space-y-1">
          {group.items.map((item) => (
            <li key={item.label}>
              <Link to={item.href}>{item.label}</Link>
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
);

export default FooterNavigation;
